/**
 * iter87.115 → iter87.368 — Shared conference-pool filter, kept ONLY
 * for the handful of already-completed CFB Weekly Spread Boost
 * tournaments (`cfb_boost_api`, removed entirely 2026-10-14 — 0
 * tournaments in active production use). Left intact deliberately so
 * those old leagues' team pool / standings / schedule keep rendering
 * their historical conference scope correctly; nothing can create a
 * new one anymore.
 *
 * Mirrors the backend `_CONF_ALIASES` map that used to live in
 * `backend/cfb_engine.py` (deleted). Bridges the admin's short handle
 * ("SEC", "ACC", "Big 10") to the long labels API-Sports feeds
 * ("Southeastern Conference", "Atlantic Coast", "Big Ten").
 *
 * Semantic: "at least one conference team on the field" — a
 * conference tournament's schedule includes cross-conference games
 * where the pool team is playing a non-conference opponent (matches
 * the semantics you asked for on iter87.115 amended: "all games that
 * have a sec team regardless of playing another sec team should be
 * in games for the sec filtered tournament").
 */

const CONF_ALIASES = {
    "sec": ["sec", "southeastern conference", "southeastern"],
    "acc": ["acc", "atlantic coast"],
    "big 10": ["big 10", "big ten", "b1g"],
    "big ten": ["big 10", "big ten", "b1g"],
    "big 12": ["big 12", "big xii"],
    "pac 12": ["pac 12", "pac-12", "pacific-12", "pacific 12"],
    "pac-12": ["pac 12", "pac-12", "pacific-12", "pacific 12"],
    "mountain west": ["mountain west", "mwc"],
    "sun belt": ["sun belt", "sunbelt"],
    "conference usa": ["conference usa", "c-usa", "cusa"],
    "mid american": ["mid american", "mid-american", "mac"],
    "aac": ["aac", "american athletic", "american athletic conference"],
    "american athletic": ["aac", "american athletic", "american athletic conference"],
};

/**
 * Returns null if the tournament isn't a CFB conference-pool tournament
 * (callers should render everything). Returns a Set<team_id> if it is
 * (callers should filter to only those team ids).
 */
export function conferenceEligibleTeamIds(tournament) {
    if (!tournament || tournament.template !== "cfb_boost_api") return null;
    const pool = (tournament.cfb || {}).pool || "";
    if (!pool.startsWith("conference:")) return null;
    const short = pool.split(":", 2)[1].trim().toLowerCase();
    const accepted = CONF_ALIASES[short] || [short];
    const ids = new Set();
    for (const t of tournament.teams || []) {
        const tc = (t.conference || "").toLowerCase();
        if (!tc) continue;
        if (accepted.some((a) => tc === a || tc.startsWith(a))) {
            ids.add(t.id);
        }
    }
    return ids;
}
